import { render, staticRenderFns } from "./vote-series-merge-notice.vue?vue&type=template&id=bac210fe&scoped=true&"
import script from "./vote-series-merge-notice.vue?vue&type=script&lang=js&"
export * from "./vote-series-merge-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac210fe",
  null
  
)

export default component.exports